import { PowerliftingLiveConfig } from '~/configs/powerliftinglive';

export function usePowerliftingLive() {
  function integrate(apiKey: string) {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('target', '_blank');
    form.setAttribute('action', `${PowerliftingLiveConfig.baseUrl}/api_ssf_link.php`);

    const apiKeyInput = document.createElement('input');
    apiKeyInput.setAttribute('type', 'hidden');
    apiKeyInput.setAttribute('name', 'api_key');
    apiKeyInput.setAttribute('value', apiKey);

    const submitBtn = document.createElement('button');
    submitBtn.setAttribute('type', 'submit');

    form.appendChild(apiKeyInput);
    form.appendChild(submitBtn);

    document.body.appendChild(form);
    form.submit();
  }

  return {
    integrate,
  };
}
